module.exports = __webpack_public_path__ + "img/jc.6c6bebd9.svg";